import { AppActionCreators } from '@nkr/store/index';
import { useAppHookContext } from '@nkr/utils/rest-api';
import React, { useEffect } from 'react';
import useCenterCompositeScoreDashboard from '@nkr/store/center/hooks/use-center-composite-score-dashboard';
import Nav from './nav';
import CompositeScore from './composite-score';
import TceFormula from './tce-formula';
import NcsScore from './ncs-score';

interface IProps {
    activeKey: string,
    centerId: number
}

const CompositeScoreDashboard: React.FC<IProps> = ({ activeKey, centerId }) => {
    const { dispatch } = useAppHookContext();
    const { results, loading, error } = useCenterCompositeScoreDashboard(centerId);

    useEffect(() => {
        const startLoading = async () => {
            dispatch(AppActionCreators.showLoadingAsync('One moment please...'));
        };

        startLoading();

        return () => {

        };
    }, [loading])

    useEffect(() => {
        if (!loading) {
            dispatch(AppActionCreators.hideLoading());
        }
    }, [loading]);

    return (
        <>
            {/* <Nav
                activeKey={activeKey}
                centerId={centerId}
                onTabSelect={() => null}
            /> */}

            {activeKey == 'COMPOSITE-SCORE' && (
                <CompositeScore
                    centerId={centerId}
                    centerAlias={results.centerAlias}
                    isPartnerCenter={results.isPartnerCenter}
                    data={results.compositeScore}
                />
            )}

            {activeKey == 'TCE-FORMULA' && (
                <TceFormula
                    centerId={centerId}
                    centerAlias={results.centerAlias}
                    isPartnerCenter={results.isPartnerCenter}
                    data={results.tceFormula}
                />
            )}

            {activeKey == 'NCS-SCORE' && (
                <NcsScore
                    centerId={centerId}
                    centerAlias={results.centerAlias}
                    isPartnerCenter={results.isPartnerCenter}
                    data={results.ncsScore}
                />
            )}
        </>
    );
}

export default CompositeScoreDashboard;